<template>
  <div>
    <div class="input-group">
      <button type="button" style="border: 3px dashed rgb(25, 163, 192);" class="col-12 primarycolor white-background p2 py4 flex line-height-1 justify-center items-center h5 not-rounded gibson" @click="launchFilePicker" :disabled="isUploadDisabled">
        <span class="pr2 relative">
          <svg fill="currentColor" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M406 195.1c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 167.7 0 222.1 0 289S54.4 410.3 121.3 410.3h84.7c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5 0-54.9 44.6-99.5 99.5-99.5 2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.2 4.9-0.4 7.5l-0.1 1.1c-0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.4 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-89.1c-6 0-10.9 4.9-10.9 10.9 0 6 4.9 10.9 10.9 10.9h89.1c59.3 0 107.6-48.3 107.6-107.6C512 243.9 464.6 196 406 195.1z"/><path d="M262.8 105.2c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 0.5 0.1 1 0.1 1.5 0.1 5.4 0 10.1-4 10.8-9.4 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 110.1 268.8 105.2 262.8 105.2z"/><path d="M312.4 320.1l-39.7-35.5c-6.8-6.1-17.2-6.1-24 0l-39.7 35.5c-4.5 4-4.9 10.9-0.9 15.4 4 4.5 10.9 4.9 15.4 0.9l26.3-23.5v134.3c0 6 4.9 10.9 10.9 10.9 6 0 10.9-4.9 10.9-10.9V312.9l26.3 23.5c2.1 1.9 4.7 2.8 7.3 2.8 3 0 6-1.2 8.1-3.6C317.3 331 316.9 324.1 312.4 320.1z"/></svg>
        </span>
        <span class="semi-bold">Vælg fil</span>
      </button>
    </div>
    <input type="file" style="display:none" ref="file" v-uploader />
    <file-upload-progress :progress="progress" style=""></file-upload-progress>
    <ul class="upload-file-list my2 pl0" v-if="uploadedFiles">
      <li class="flex justify-start items-center" v-for="uploaded_file in uploadedFiles" :key="uploaded_file.id">
        <span class="h5 gibson regular darkblue line-height-1 mr3" style="word-break: break-word;">{{uploaded_file}}</span>
        <button class="not-rounded delete-button p1 border-none" v-confirm="{ok: confirmDelete(uploaded_file)}" :key="uploaded_file" tooltip="Slet" v-if="index !== 0">
          <span>
            <i class="el-icon-delete"></i>
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
  /* eslint-disable handle-callback-err,curly */
  import fileUploadProgress from './file-upload-progress.vue'
  /* eslint-disable indent */
  export default {
    components: {fileUploadProgress},
    props: {
      buttonText: {
        default: 'Choose File'
      },
      token: {
        required: true
      },
      module: {
        required: true
      },
      moduleId: {
        default: ''
      },
      clearFile: {
        default: false
      }
    },
    directives: {
      uploader: {
        bind (el, binding, vnode) {
          el.addEventListener('change', e => {
            vnode.context.file = e.target.files[0]
          })
        }
      }
    },
    watch: {
      file (file) {
       localStorage.setItem('uploadFinish', false)
       // eslint-disable-next-line no-unused-expressions
       let fileExtension = file.name.substr((file.name.lastIndexOf('.') + 1)).toLowerCase()
       if (this.allowed_file_extensions.indexOf(fileExtension) === -1) {
        this.progress = 0
        this.isUploadDisabled = false
        this.$toastr('error', 'Fil ikke tilladt')
      } else if (file.size > 27600000) {
        this.progress = 0
        this.isUploadDisabled = false
        this.$toastr('error', 'Filstørrelsesgrænsen overskredet')
      } else {
        // console.log(file)
        this.progress = 10
        this.salesPerson = localStorage.getItem('id_token_portal')
        let formData = new FormData()
        formData.append('operation', 'userInboxUpload')
        formData.append('file', file)
        formData.append('salesPerson', this.salesPerson)
        formData.append('id', this.moduleId)
        // var data = {operation: 'userTilbudUpload', salesPerson: this.salesPerson, id: this.moduleId, file: file}
        this.$http.post('', formData, { emulateJSON: true,
        // axios.post('https://www.kundematch.dk/partnerService.php/', formData, {
        //    headers: formData.getHeaders(),
            onUploadProgress: function (progressEvent) {
              this.progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
            }.bind(this)
        //   })
        })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.file) {
              this.$toastr('success', 'Gennemført')
              localStorage.setItem('uploadFinish', true)
              localStorage.removeItem('uploadFinish')
              this.uploadedFiles.push(res.file)
              this.$emit('UpdateTilbudpdf', this.uploadedFiles)
            }
            this.progress = 100
            this.isUploadDisabled = false
          },
          response => {
            alert('error')
            this.progress = 0
            this.isUploadDisabled = false
          }
        )
      }
    },
    clearFile (val) {
        this.uploadedFiles = []
        this.$emit('UpdateTilbudpdf', this.uploadedFiles)
      },
      moduleId (val) {
        if (val)
          this.fetchUploads()
      }
    },
    mounted () {
      if (this.moduleId)
        this.fetchUploads()
      this.allowed_file_extensions = ['pdf']
    },
    computed: {
      authToken () {
        return localStorage.getItem('auth_token')
      },
      isFileSelected () {
        return this.isUploadDisabled
      }
    },
    methods: {
      launchFilePicker () {
        this.isUploadDisabled = false
        this.$refs.file.click()
      },
      reload () {
        this.salesPerson = localStorage.getItem('id_token_portal')
        var data = {operation: 'userExtention', salesPerson: localStorage.getItem('id_token_portal')}
        this.$http.post('', data, {emulateJSON: true})
          .then(
            response => {
              var res = response.body
              this.allowed_file_extensions = res
            },
            response => {
              alert('error')
            }
          )
      },
      cancelUpload () {
        if (this.request) {
          this.request.abort()
        }
        this.isUploadDisabled = false
      },
      arrayRemove (arr, value) {
        return arr.filter(function (ele) {
         return ele !== value
       })
      },
      confirmDelete (uploadedFile) {
        return dialog => this.deleteUpload(uploadedFile)
      },
      deleteUpload (uploadedFile) {
       this.uploadedFiles = this.arrayRemove(this.uploadedFiles, uploadedFile)
       this.$emit('UpdateTilbudpdf', this.uploadedFiles)
     },
     fetchUploads () {
        // this.uploadedFiles = []
      }
    },
    data () {
      return {
        file: '',
        index: null,
        isUploadDisabled: false,
        progress: 0,
        uploadedFiles: [],
        allowed_file_extensions: []
      }
    },
    created () {
      if (screen.width <= 640) {
        this.showMobile = true
      } else {
        this.showMobile = false
      }
      if (screen.width >= 1900) {
        this.showXXL = true
      } else {
        this.showXXL = false
      }
    }
  }
</script>
<style v-if="showMobile">
.input-group > .primarycolor {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.input-group > .primarycolor > span > svg {
  width:36px;
  height:36px;
}
.img-loader {
    background: white;
    width:100%;
    height:100%;
  }
  .center-xy {
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  }
  .img-loader .loader::before, .img-loader .loader::after {
    background: white;
  }
</style>



// WEBPACK FOOTER //
// file-upload-input-pdfonly.vue?003c34af